import React, {useState} from "react";
import BioSpinner from "src/RCMP/BioSpinner";

const RegisterFormStep3 = ({params, onDone, back}) => {
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        password: "",
        repassword: "",
    });
    const [passwordVisibility, setPasswordVisibility] = useState({
        password: false,
        repassword: false,
    });

    const [errors, setErrors] = useState({
        password: "",
        repassword: "",
    });

    const isPasswordValid = (password) => {
        const minLength = 6;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        const hasSymbol = /[@#$%^&*(),.?":{}|<>]/.test(password);

        return (
            password.length >= minLength &&
            hasUpperCase &&
            hasLowerCase &&
            hasNumber &&
            hasSymbol
        );
    };

    const handleInputChange = (event) => {
        const {name, value} = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors({
            ...errors,
            [name]: "",
        });
    };

    const handleVisibilityToggle = (field) => {
        setPasswordVisibility((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const {password, repassword} = formData;

        if (!isPasswordValid(password)) {
            setErrors((prev) => ({
                ...prev,
                password:
                    "Password must be at least 6 characters and include uppercase, lowercase, a number, and a symbol.",
            }));
            return;
        }

        if (repassword !== password) {
            setErrors((prev) => ({
                ...prev,
                repassword: "Passwords do not match.",
            }));
            return;
        }

        setLoader(true);
        try {
            setTimeout(() => {
                setLoader(false);
                onDone(formData.password);
            }, 100);
        } catch (error) {
            setLoader(false);
        }
    };

    return (
        <div className="w-100 py-5">
            <form
                className="bg-gray-200 pb-4 rounded-lg px-3 max-w-full w-[400px] shadow-lg mx-auto"
                onSubmit={handleSubmit}
            >
                <div className="flex flex-col px-3 py-4 items-center gap-2 content-center">
                    <h1 className="font-bold text-xl">Set Your Password</h1>
                    <p className="text-sm text-gray-700 mt-2 text-center">
                        Dear <span className="font-semibold">{params.name} {params.midName} {params.lastName}</span>,<br />
                        Please set a password for your account associated with <span className="font-semibold">{params.email}</span>.
                    </p>
                </div>
                <div className="flex flex-col w-full items-start gap-3 font-14 content-start py-2">
                    {/* Password Field */}
                    <label className="w-full text-start">Password:</label>
                    <div className="relative w-full">
                        <input
                            type={passwordVisibility.password ? "text" : "password"}
                            name="password"
                            value={formData.password}
                            onChange={handleInputChange}
                            required
                            className={`border w-full rounded-md px-3 py-2 ${
                                errors.password ? "border-red-500" : ""
                            }`}
                        />
                        <button
                            type="button"
                            onClick={() => handleVisibilityToggle("password")}
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600"
                        >
                            {passwordVisibility.password ? "Hide" : "Show"}
                        </button>
                    </div>
                    {errors.password && (
                        <span className="text-sm text-red-500">{errors.password}</span>
                    )}

                    {/* Confirm Password Field */}
                    <label className="w-full text-start">Confirm Password:</label>
                    <div className="relative w-full">
                        <input
                            type={passwordVisibility.repassword ? "text" : "password"}
                            name="repassword"
                            value={formData.repassword}
                            onChange={handleInputChange}
                            required
                            className={`border w-full rounded-md px-3 py-2 ${
                                errors.repassword ? "border-red-500" : ""
                            }`}
                        />
                        <button
                            type="button"
                            onClick={() => handleVisibilityToggle("repassword")}
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600"
                        >
                            {passwordVisibility.repassword ? "Hide" : "Show"}
                        </button>
                    </div>
                    {errors.repassword && (
                        <span className="text-sm text-red-500">{errors.repassword}</span>
                    )}
                </div>

                <div className="flex gap-2 w-full my-4 flex-row">
                    <button
                        type="button"
                        onClick={back}
                        className="border border-black text-black justify-center items-center flex w-full rounded-md py-2 px-5"
                        disabled={loader}
                    >
                        {loader ? <BioSpinner animation="border" size="sm"/> : "Back"}
                    </button>
                    <button
                        type="submit"
                        className="bg-black justify-center items-center flex w-full text-white rounded-md py-2 px-5"
                        disabled={loader}
                    >
                        {loader ? <BioSpinner animation="border" size="sm"/> : "Submit"}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default RegisterFormStep3;